import React from 'react';
import {
    StyledTabContentContianer,
    TabContent,
    TabContentFont,
    TabSelectedBorder,
} from './physicianDetailTab.styled';
const PhysicianDetailTabList = ({ label, isTabActive, tabSwitch, id }) => {
    return (
        <>
            <StyledTabContentContianer
                onClick={() => {
                    tabSwitch(id);
                }}
                isSelected={isTabActive}
                cursor={'pointer'}
            >
                <TabContent isPending={false} isBatch={false}>
                    <TabContentFont isSelected={isTabActive}>
                        {label}
                    </TabContentFont>
                </TabContent>
                <TabSelectedBorder isSelected={isTabActive} />
            </StyledTabContentContianer>
        </>
    );
};

export default PhysicianDetailTabList;
